import React from 'react';
import PropTypes from 'prop-types';

const TargetLink = props => {
  if (!props.renderIf) return (<div>{ props.children }</div>);

  return (
    <a
      style={props.style}
      href={props.href}
      target={props.target}
      rel="noopener noreferrer"
    >
      {
        props.children
      }
    </a>
  );
};

TargetLink.propTypes = {
  children: PropTypes.node.isRequired,
  href: PropTypes.string.isRequired,
  renderIf: PropTypes.bool.isRequired,
  target: PropTypes.string,
  style: PropTypes.object,
};

TargetLink.defaultProps = {
  target: '_blank',
  style: {},
};

export default TargetLink;



/** WEBPACK FOOTER **
 ** ./src/components/target-link/index.js
 **/